import memoizeOne from 'memoize-one';
import i18n from 'Utilities/i18n';
/** Reference used to store urls */
export const urls = {
  lslApi: '',
  lsApi: '',
  libreSharingApiUrl: '',
  libreSharingApiCountryUrl: '',
  libreSharingApiCountryUrls: {},
  oauth: {
    consentUrl: ''
  }
};
const getCountryBasedUrl = (country, countryUrls, fallbackUrl) => {
  const url = country && countryUrls?.[country] ? countryUrls[country] : fallbackUrl;
  return normalizeUrl(url);
};

/**
 * Sets the urls object to be ready for services
 * - config: object - The environment config
 */
export const setUrls = (config, country) => {
  const {
    lslApi,
    lsApi,
    libreSharingApiUrl,
    libreSharingApiCountryUrl,
    libreSharingApiCountryUrls,
    oauth
  } = config;
  Object.assign(urls, {
    lslApi: lslApi || urls.lslApi,
    lsApi: lsApi || urls.lsApi,
    libreSharingApiUrl: libreSharingApiUrl || lsApi || urls.libreSharingApiUrl,
    libreSharingApiCountryUrl: getCountryBasedUrl(country || 'US', libreSharingApiCountryUrls, libreSharingApiCountryUrl || libreSharingApiUrl),
    libreSharingApiCountryUrls: libreSharingApiCountryUrls || urls.libreSharingApiCountryUrls,
    oauth: {
      consentUrl: oauth?.consentUrl || urls.oauth.consentUrl || ''
    }
  });
};
export const getFromAccountType = memoizeOne((item, accountType) => {
  if (!accountType) {
    return item.pat || item.default || {};
  }
  if (accountType === 'hcp') {
    accountType = 'pro';
  } else if (accountType === 'patient') {
    accountType = 'pat';
  }
  return item[accountType] || item.default || {};
});
export const convertMgToMmol = value => Number((Number(value) / 18).toFixed(1));
export const convertMmolToMg = value => Number((Number(value) * 18).toFixed(0));
export const isSecRuleError = (data = {}) => !!data.code;

/**
 * Get the translated error message for the corresponding security rule error
 *
 * @param {*} secRuleErr Security rule error definition
 * @param {number} secRuleErr.code Rule code identifier
 * @param {*} secRuleErr.data Rule data context
 * @param {string} secRuleErr.message Rule brief message
 */
export const getSecurityErrorMessage = msg => {
  let errMsg = '';
  switch (msg.code) {
    case 11:
      // Change lock
      // Interval is in seconds, error message expects hours
      errMsg = i18n.t('SecurityRules.' + msg.code, {
        count: (msg.data !== undefined ? msg.data.interval : 0) / 60 / 60
      });
      break;
    case 14:
      // Generations
      // Limit of 0 means no reusable passwords
      errMsg = i18n.t(['SecurityRules.' + msg.code + '_' + (msg.data && msg.data.limit), 'SecurityRules.' + msg.code], {
        count: msg.data && msg.data.limit
      });
      break;
    case 60:
      // Lockout time is in seconds, error message expects minutes
      errMsg = i18n.t('SecurityRules.' + msg.code, {
        count: msg.data.lockout / 60
      });
      break;
    default:
      {
        const d = msg;
        errMsg = i18n.t('SecurityRules.' + d.code, {
          count: d.data && d.data.limit
        });
      }
  }
  return errMsg;
};
export const normalizeUrl = url => {
  const normalizedUrl = url?.replace(/\/v1\/?$/, '/') ?? '';
  return normalizedUrl;
};